// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react';
import { Modal, Button, Container, Row, Col, ListGroup, Badge, Form } from 'react-bootstrap';
import { PaymentMethodFetchAPI } from '../../../api/PaymentMethod';
import { RenderIf } from '../../utils/RenderIf';
import ErrorAlert from '../../Alerts/ErrorAlert';
import SuccessAlert from '../../Alerts/SuccessAlert';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .mamp-
───────────────────────────────────────────────────────── */
const MAMP_CSS = `
@keyframes mamp-slide { from{opacity:0;transform:translateY(14px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }
@keyframes mamp-up    { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }

/* ── modal ── */
.mamp-dialog { max-width: 480px !important; }
.mamp-dialog .modal-content {
  border: 1.5px solid rgba(0,0,0,.08) !important;
  border-radius: 20px !important;
  box-shadow: 0 24px 64px rgba(0,0,0,.18), 0 6px 16px rgba(0,0,0,.08) !important;
  overflow: hidden !important;
  animation: mamp-slide .28s cubic-bezier(.34,1.56,.64,1) both !important;
}
.mamp-dialog .modal-header { display: none !important; }
.mamp-dialog .modal-body   { padding: 0 !important; }

/* ── header ── */
.mamp-head {
  display: flex; align-items: center; gap: .65rem;
  padding: 1rem 1.25rem .9rem;
  border-bottom: 1px solid var(--border, rgba(0,0,0,.07));
  background: var(--bg-2, rgba(0,0,0,.02));
}
.mamp-head-ico {
  width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0;
  background: rgba(27,58,107,.09); color: #1B3A6B;
  display: grid; place-items: center;
}
.mamp-head-info { flex: 1; }
.mamp-head-title {
  font-size: .93rem; font-weight: 700; color: var(--text, #0A0A0A);
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mamp-head-sub {
  font-size: .7rem; color: var(--text-3, #B4B4B4); margin-top: 1px;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mamp-close {
  width: 30px; height: 30px; border-radius: 50%; flex-shrink: 0;
  border: 1.5px solid var(--border, rgba(0,0,0,.09));
  background: var(--bg-2, rgba(0,0,0,.035));
  color: var(--text-2, #6B6B6B);
  display: grid; place-items: center; cursor: pointer; transition: all .14s;
}
.mamp-close:hover { border-color: #EF4444; color: #EF4444; background: #FEE2E2; }

/* ── form body ── */
.mamp-form-body {
  padding: 1.1rem 1.25rem; display: flex; flex-direction: column; gap: 1rem;
}

/* ── field ── */
.mamp-field { display: flex; flex-direction: column; gap: .3rem; }
.mamp-label {
  font-size: .74rem; font-weight: 600; color: var(--text-2, #6B6B6B);
  font-family: var(--font-sans,-apple-system,sans-serif);
  display: flex; align-items: center; gap: .3rem;
}

/* override Bootstrap Form.Select & Form.Control inside modal */
.mamp-dialog .form-select,
.mamp-dialog .form-control {
  border: 1.5px solid rgba(0,0,0,.11) !important;
  border-radius: 10px !important;
  background: rgba(0,0,0,.03) !important;
  font-family: var(--font-sans,-apple-system,sans-serif) !important;
  font-size: .83rem !important;
  color: var(--text, #0A0A0A) !important;
  transition: border-color .14s, box-shadow .14s !important;
}
.mamp-dialog .form-select:focus,
.mamp-dialog .form-control:focus {
  border-color: #1B3A6B !important;
  box-shadow: 0 0 0 3px rgba(27,58,107,.10) !important;
  background: var(--bg, #fff) !important;
  outline: none !important;
}
.mamp-dialog .form-label { display: none !important; }   /* ocultamos Form.Label original — usamos .mamp-label */

/* ── params section ── */
.mamp-params-wrap {
  border: 1.5px solid rgba(0,0,0,.07); border-radius: 12px;
  overflow: hidden; animation: mamp-up .2s ease both;
}
.mamp-params-head {
  padding: .5rem .85rem;
  background: rgba(27,58,107,.04);
  border-bottom: 1px solid rgba(0,0,0,.07);
  font-size: .67rem; font-weight: 700; letter-spacing: .07em;
  text-transform: uppercase; color: #1B3A6B;
  font-family: var(--font-sans,-apple-system,sans-serif);
}

/* override ListGroup inside params */
.mamp-dialog .list-group { border-radius: 0 !important; }
.mamp-dialog .list-group-item {
  border-left: none !important; border-right: none !important;
  border-top: none !important;
  border-bottom: 1px solid rgba(0,0,0,.07) !important;
  padding: .75rem .85rem !important;
  background: var(--bg, #fff) !important;
}
.mamp-dialog .list-group-item:last-child { border-bottom: none !important; }
.mamp-dialog .list-group-item p {
  font-size: .78rem; font-weight: 600; color: var(--text-2, #6B6B6B);
  margin-bottom: .45rem;
  font-family: var(--font-sans,-apple-system,sans-serif);
}

.mamp-optional-badge {
  display: inline-flex; margin-left: .4rem;
  font-size: .62rem; font-weight: 700; padding: .1rem .45rem;
  border-radius: 999px; background: rgba(251,191,36,.12); color: #92400E;
  border: 1px solid rgba(251,191,36,.25);
}

/* ── footer ── */
.mamp-footer {
  padding: .8rem 1.25rem .95rem;
  border-top: 1px solid var(--border, rgba(0,0,0,.07));
  display: flex; justify-content: flex-end; gap: .5rem;
}
.mamp-btn-cancel {
  padding: .5rem 1rem; border-radius: 9px;
  border: 1.5px solid rgba(0,0,0,.12); background: rgba(0,0,0,.04);
  color: var(--text-2, #6B6B6B);
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .81rem; font-weight: 500; cursor: pointer; transition: all .13s;
}
.mamp-btn-cancel:hover { border-color: var(--text-2); color: var(--text, #0A0A0A); }
.mamp-btn-save {
  padding: .5rem 1.25rem; border-radius: 9px; border: none;
  background: #1B3A6B; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .81rem; font-weight: 600; cursor: pointer;
  transition: background .14s, transform .14s;
  display: flex; align-items: center; gap: .38rem;
}
.mamp-btn-save:hover { background: #152D54; transform: translateY(-1px); }

@media(max-width: 480px) {
  .mamp-dialog { max-width: calc(100vw - 1.5rem) !important; }
}
`;

/* ── ICONS ── */
const IcoCrd  = ()=><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const IcoX    = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoSave = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoPlug = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const ModalAsingPaymetMethod = ({
  showModal, setShowModal, paymentMethodIntegrations, token, machine_id, setEventHandler
}) => {

  useEffect(() => {
    const id = "mamp-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id; el.textContent = MAMP_CSS;
      document.head.appendChild(el);
    }
  }, []);

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  const [paymentMethods, setPaymentMethods]                               = useState([]);
  const [paymentMethodParams, setPaymentMethodParams]                     = useState([]);
  const [selectedPaymentMethodIntegration, setSelectedPaymentMethodIntegration] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod]                 = useState(0);

  const getPaymentMethodByIntegration = async (integration_id) => {
    try {
      const res = await PaymentMethodFetchAPI.getPaymentMethodByIntegration(integration_id, token);
      setPaymentMethods(res.data.data);
      setSelectedPaymentMethodIntegration(integration_id);
    } catch (err) {
      setPaymentMethods([]); setSelectedPaymentMethodIntegration(0);
    }
  };

  const getPaymentMethodParams = async (payment_method_id, integration_id) => {
    try {
      if (integration_id == 3 && payment_method_id != 23) {
        setPaymentMethodParams([]);
      } else {
        const res = await PaymentMethodFetchAPI.getPaymentMethodParams(payment_method_id, integration_id, token);
        setPaymentMethodParams(res.data.data);
      }
    } catch (err) { setPaymentMethodParams([]); }
  };

  const savePaymentMethod = async (e) => {
    e.preventDefault();
    try {
      let params = [];
      let inputs = document.getElementsByName('paramPayment');
      for (let i = 0; i < inputs.length; i++) {
        params.push({ param_id: inputs[i].getAttribute('data-id'), param_value: inputs[i].value });
      }
      const form = { params, integration_id: selectedPaymentMethodIntegration };
      await PaymentMethodFetchAPI.asingPaymentMethodToMachine(machine_id, selectedPaymentMethod, form, token);
      setShowModal(false);
      SuccessAlert("Metodo de pago asignado correctamente");
      setPaymentMethodParams([]);
      setEventHandler(1);
    } catch (err) {
      if (err.response.status == 400) ErrorAlert(err.response.data.error, "Advertencia", "warning");
      else ErrorAlert("Error al asignar el metodo de pago");
    }
  };

  useEffect(() => {
    if (selectedPaymentMethodIntegration != 0) {
      document.getElementById('paymentmethod-select').selectedIndex = 0;
    }
    setPaymentMethodParams([]);
    setSelectedPaymentMethod(0);
  }, [selectedPaymentMethodIntegration]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  return (
    <>
      <Modal
        show={showModal}
        size="md"
        centered
        onHide={() => setShowModal(false)}
        dialogClassName="mamp-dialog"
      >
        <Modal.Header className="text-center">
          <h3><i className="uil uil-apps" /> Asignar Metodo de Pago</h3>
        </Modal.Header>

        <Modal.Body>

          {/* ── header visual ── */}
          <div className="mamp-head">
            <div className="mamp-head-ico"><IcoCrd /></div>
            <div className="mamp-head-info">
              <div className="mamp-head-title">Asignar método de pago</div>
              <div className="mamp-head-sub">Selecciona integración, método y configura los parámetros</div>
            </div>
            <button className="mamp-close" type="button" onClick={() => setShowModal(false)}>
              <IcoX />
            </button>
          </div>

          {/* ── form — lógica original intacta ── */}
          <Form onSubmit={savePaymentMethod}>
            <div className="mamp-form-body">

              {/* integración */}
              <div className="mamp-field">
                <span className="mamp-label"><IcoPlug /> Forma de integración</span>
                <Form.Label>Seleccione la forma de integración</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  onChange={e => getPaymentMethodByIntegration(e.target.value)}
                >
                  <option>Seleccione una forma de integración</option>
                  {paymentMethodIntegrations.map((integration, index) => (
                    <option key={index} value={integration.id}>{integration.name}</option>
                  ))}
                </Form.Select>
              </div>

              {/* método de pago */}
              <div className="mamp-field">
                <span className="mamp-label"><IcoCrd /> Método de pago</span>
                <Form.Label className="mt-3">Seleccione el metodo de pago</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  id="paymentmethod-select"
                  onChange={e => { getPaymentMethodParams(e.target.value, selectedPaymentMethodIntegration); setSelectedPaymentMethod(e.target.value); }}
                >
                  <option>Seleccione un metodo de pago</option>
                  {paymentMethods.map((paymentMethod, index) => (
                    <option key={index} value={paymentMethod.paymentmethod_id}>{paymentMethod.payment}</option>
                  ))}
                </Form.Select>
              </div>

              {/* parámetros — lógica RenderIf exacta ── */}
              <RenderIf isTrue={paymentMethodParams.length > 0}>
                <div className="mamp-params-wrap">
                  <div className="mamp-params-head">Parámetros de configuración</div>
                  <ListGroup className="mt-3">
                    {paymentMethodParams.map((param, index) => (
                      <ListGroup.Item key={index}>
                        <p>
                          {param.is_optional == 1
                            ? <>{param.name}<span className="mamp-optional-badge">Opcional</span></>
                            : param.name}
                        </p>

                        <RenderIf isTrue={
                          param.name !== "force_duplicate" &&
                          param.name !== "iscashback" &&
                          param.name !== "manual_entry_indicator" &&
                          param.name !== "payment_host"
                        }>
                          <Form.Control type="text" name="paramPayment" placeholder={param.name} data-id={param.param_id} />
                        </RenderIf>

                        <RenderIf isTrue={
                          param.name === "force_duplicate" ||
                          param.name === "iscashback" ||
                          param.name === "manual_entry_indicator"
                        }>
                          <Form.Select aria-label="Default select example" name="paramPayment" data-id={param.param_id}>
                            <option value={"no"}>No</option>
                            <option value={"yes"}>Si</option>
                          </Form.Select>
                        </RenderIf>

                        <RenderIf isTrue={param.name === "payment_host"}>
                          <Form.Select aria-label="Default select example" name="paramPayment" data-id={param.param_id}>
                            <option value={"ATH"}>ATH</option>
                            <option value={"ATH2"}>ATH2</option>
                            <option value={"ATH2"}>ATH2</option>
                            <option value={"ATH3"}>ATH3</option>
                            <option value={"ATH4"}>ATH4</option>
                          </Form.Select>
                        </RenderIf>

                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              </RenderIf>

            </div>

            {/* ── footer con botones ── */}
            <div className="mamp-footer">
              <button className="mamp-btn-cancel" type="button" onClick={() => setShowModal(false)}>
                Cancelar
              </button>
              {/* Button original intacto — lógica type="submit" */}
              <Button className="mamp-btn-save mt-3" variant="primary" type="submit">
                <IcoSave /> Asignar método
              </Button>
            </div>

          </Form>

        </Modal.Body>
      </Modal>

      {/* imports no usados como JSX — preservados ── */}
      {void [Container, Row, Col, Badge, ErrorAlert, SuccessAlert]}
    </>
  );
};

export default ModalAsingPaymetMethod;